import { dateToString } from '@/utils/date-utils';

export default class RequestDTO {
  api_name: string;
  trans_dttm: string;

  constructor(api_name: string, dateTime = new Date()) {
    this.api_name = api_name;
    this.trans_dttm = dateToString(dateTime, 'YYYYMMDDHHmmssSSS');
  }
}
